const state = {
  status: null,
  error: null,
  loginData: null
};

export default state;
